(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __reExport = (target, module, desc) => {
    if (module && typeof module === "object" || typeof module === "function") {
      for (let key of __getOwnPropNames(module))
        if (!__hasOwnProp.call(target, key) && key !== "default")
          __defProp(target, key, { get: () => module[key], enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable });
    }
    return target;
  };
  var __toModule = (module) => {
    return __reExport(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", module && module.__esModule && "default" in module ? { get: () => module.default, enumerable: true } : { value: module, enumerable: true })), module);
  };

  // node_modules/easytimer.js/dist/easytimer.js
  var require_easytimer = __commonJS({
    "node_modules/easytimer.js/dist/easytimer.js"(exports, module) {
      (function(global, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory(global.easytimer = {}));
      })(exports, function(exports2) {
        "use strict";
        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread2(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
              _defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
          return target;
        }
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
            return typeof obj2;
          } : function(obj2) {
            return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          }, _typeof(obj);
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function leftPadding(string, padLength, character) {
          var i;
          var characters = "";
          string = typeof string === "number" ? String(string) : string;
          if (string.length > padLength) {
            return string;
          }
          for (i = 0; i < padLength; i = i + 1) {
            characters += String(character);
          }
          return (characters + string).slice(-characters.length);
        }
        function TimeCounter() {
          this.reset();
        }
        TimeCounter.prototype.toString = function() {
          var units = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["hours", "minutes", "seconds"];
          var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ":";
          var leftZeroPadding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
          units = units || ["hours", "minutes", "seconds"];
          separator = separator || ":";
          leftZeroPadding = leftZeroPadding || 2;
          var arrayTime = [];
          var i;
          for (i = 0; i < units.length; i = i + 1) {
            if (this[units[i]] !== void 0) {
              if (units[i] === "secondTenths") {
                arrayTime.push(this[units[i]]);
              } else {
                arrayTime.push(leftPadding(this[units[i]], leftZeroPadding, "0"));
              }
            }
          }
          return arrayTime.join(separator);
        };
        TimeCounter.prototype.reset = function() {
          this.secondTenths = 0;
          this.seconds = 0;
          this.minutes = 0;
          this.hours = 0;
          this.days = 0;
        };
        function EventEmitter() {
          this.events = {};
        }
        EventEmitter.prototype.on = function(event, listener) {
          var _this = this;
          if (!Array.isArray(this.events[event])) {
            this.events[event] = [];
          }
          this.events[event].push(listener);
          return function() {
            return _this.removeListener(event, listener);
          };
        };
        EventEmitter.prototype.removeListener = function(event, listener) {
          if (Array.isArray(this.events[event])) {
            var eventIndex = this.events[event].indexOf(listener);
            if (eventIndex > -1) {
              this.events[event].splice(eventIndex, 1);
            }
          }
        };
        EventEmitter.prototype.removeAllListeners = function(event) {
          if (!event) {
            this.events = {};
          } else if (Array.isArray(this.events[event])) {
            this.events[event] = [];
          }
        };
        EventEmitter.prototype.emit = function(event) {
          var _this2 = this;
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          if (Array.isArray(this.events[event])) {
            this.events[event].forEach(function(listener) {
              return listener.apply(_this2, args);
            });
          }
        };
        var SECOND_TENTHS_PER_SECOND = 10;
        var SECONDS_PER_MINUTE = 60;
        var MINUTES_PER_HOUR = 60;
        var HOURS_PER_DAY = 24;
        var SECOND_TENTHS_POSITION = 0;
        var SECONDS_POSITION = 1;
        var MINUTES_POSITION = 2;
        var HOURS_POSITION = 3;
        var DAYS_POSITION = 4;
        var SECOND_TENTHS = "secondTenths";
        var SECONDS = "seconds";
        var MINUTES = "minutes";
        var HOURS = "hours";
        var DAYS = "days";
        var VALID_INPUT_VALUES = [SECOND_TENTHS, SECONDS, MINUTES, HOURS, DAYS];
        var unitsInMilliseconds = {
          secondTenths: 100,
          seconds: 1e3,
          minutes: 6e4,
          hours: 36e5,
          days: 864e5
        };
        var groupedUnits = {
          secondTenths: SECOND_TENTHS_PER_SECOND,
          seconds: SECONDS_PER_MINUTE,
          minutes: MINUTES_PER_HOUR,
          hours: HOURS_PER_DAY
        };
        function mod(number, module2) {
          return (number % module2 + module2) % module2;
        }
        function Timer2() {
          var defaultParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var counters = new TimeCounter();
          var totalCounters = new TimeCounter();
          var intervalId;
          var eventEmitter = new EventEmitter();
          var running = false;
          var paused = false;
          var precision;
          var timerTypeFactor;
          var customCallback;
          var timerConfig = {};
          var currentParams;
          var targetValues;
          var startValues;
          var countdown;
          var startingDate;
          var targetDate;
          var eventData = {
            detail: {
              timer: this
            }
          };
          setParams(defaultParams);
          function updateCounters(precision2, roundedValue) {
            var unitsPerGroup = groupedUnits[precision2];
            totalCounters[precision2] = roundedValue;
            if (precision2 === DAYS) {
              counters[precision2] = Math.abs(roundedValue);
            } else if (roundedValue >= 0) {
              counters[precision2] = mod(roundedValue, unitsPerGroup);
            } else {
              counters[precision2] = mod(unitsPerGroup - mod(roundedValue, unitsPerGroup), unitsPerGroup);
            }
          }
          function updateDays(value) {
            return updateUnitByPrecision(value, DAYS);
          }
          function updateHours(value) {
            return updateUnitByPrecision(value, HOURS);
          }
          function updateMinutes(value) {
            return updateUnitByPrecision(value, MINUTES);
          }
          function updateSeconds(value) {
            return updateUnitByPrecision(value, SECONDS);
          }
          function updateSecondTenths(value) {
            return updateUnitByPrecision(value, SECOND_TENTHS);
          }
          function updateUnitByPrecision(value, precision2) {
            var previousValue = totalCounters[precision2];
            updateCounters(precision2, calculateIntegerUnitQuotient(value, unitsInMilliseconds[precision2]));
            return totalCounters[precision2] !== previousValue;
          }
          function stopTimerAndResetCounters() {
            stopTimer();
            resetCounters();
          }
          function stopTimer() {
            clearInterval(intervalId);
            intervalId = void 0;
            running = false;
            paused = false;
          }
          function setParamsAndStartTimer(params) {
            if (!isPaused()) {
              setParams(params);
            } else {
              startingDate = calculateStartingDate();
              targetValues = setTarget(currentParams.target);
            }
            startTimer();
          }
          function startTimer() {
            var interval = unitsInMilliseconds[precision];
            if (isTargetAchieved(roundTimestamp(Date.now()))) {
              return;
            }
            intervalId = setInterval(updateTimerAndDispatchEvents, interval);
            running = true;
            paused = false;
          }
          function calculateStartingDate() {
            return roundTimestamp(Date.now()) - totalCounters.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
          }
          function updateTimerAndDispatchEvents() {
            var currentTime = roundTimestamp(Date.now());
            var valuesUpdated = updateTimer();
            dispatchEvents(valuesUpdated);
            customCallback(eventData.detail.timer);
            if (isTargetAchieved(currentTime)) {
              stop();
              dispatchEvent("targetAchieved", eventData);
            }
          }
          function updateTimer() {
            var currentTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : roundTimestamp(Date.now());
            var elapsedTime = timerTypeFactor > 0 ? currentTime - startingDate : startingDate - currentTime;
            var valuesUpdated = {};
            valuesUpdated[SECOND_TENTHS] = updateSecondTenths(elapsedTime);
            valuesUpdated[SECONDS] = updateSeconds(elapsedTime);
            valuesUpdated[MINUTES] = updateMinutes(elapsedTime);
            valuesUpdated[HOURS] = updateHours(elapsedTime);
            valuesUpdated[DAYS] = updateDays(elapsedTime);
            return valuesUpdated;
          }
          function roundTimestamp(timestamp) {
            return Math.floor(timestamp / unitsInMilliseconds[precision]) * unitsInMilliseconds[precision];
          }
          function dispatchEvents(valuesUpdated) {
            if (valuesUpdated[SECOND_TENTHS]) {
              dispatchEvent("secondTenthsUpdated", eventData);
            }
            if (valuesUpdated[SECONDS]) {
              dispatchEvent("secondsUpdated", eventData);
            }
            if (valuesUpdated[MINUTES]) {
              dispatchEvent("minutesUpdated", eventData);
            }
            if (valuesUpdated[HOURS]) {
              dispatchEvent("hoursUpdated", eventData);
            }
            if (valuesUpdated[DAYS]) {
              dispatchEvent("daysUpdated", eventData);
            }
          }
          function isTargetAchieved(currentDate) {
            return targetValues instanceof Array && currentDate >= targetDate;
          }
          function resetCounters() {
            counters.reset();
            totalCounters.reset();
          }
          function setParams(params) {
            params = params || {};
            precision = checkPrecision(params.precision);
            customCallback = typeof params.callback === "function" ? params.callback : function() {
            };
            countdown = params.countdown === true;
            timerTypeFactor = countdown === true ? -1 : 1;
            if (_typeof(params.startValues) === "object") {
              setStartValues(params.startValues);
            } else {
              startValues = null;
            }
            startingDate = calculateStartingDate();
            updateTimer();
            if (_typeof(params.target) === "object") {
              targetValues = setTarget(params.target);
            } else if (countdown) {
              params.target = {
                seconds: 0
              };
              targetValues = setTarget(params.target);
            } else {
              targetValues = null;
            }
            timerConfig = {
              precision,
              callback: customCallback,
              countdown: _typeof(params) === "object" && params.countdown === true,
              target: targetValues,
              startValues
            };
            currentParams = params;
          }
          function checkPrecision(precision2) {
            precision2 = typeof precision2 === "string" ? precision2 : SECONDS;
            if (!isValidInputValue(precision2)) {
              throw new Error("Error in precision parameter: ".concat(precision2, " is not a valid value"));
            }
            return precision2;
          }
          function isValidInputValue(value) {
            return VALID_INPUT_VALUES.indexOf(value) >= 0;
          }
          function configInputValues(inputValues) {
            var values;
            if (_typeof(inputValues) === "object") {
              if (inputValues instanceof Array) {
                if (inputValues.length !== 5) {
                  throw new Error("Array size not valid");
                }
                values = inputValues;
              } else {
                for (var value in inputValues) {
                  if (VALID_INPUT_VALUES.indexOf(value) < 0) {
                    throw new Error("Error in startValues or target parameter: ".concat(value, " is not a valid input value"));
                  }
                }
                values = [inputValues.secondTenths || 0, inputValues.seconds || 0, inputValues.minutes || 0, inputValues.hours || 0, inputValues.days || 0];
              }
            }
            values = values.map(function(value2) {
              return parseInt(value2, 10);
            });
            var secondTenths = values[SECOND_TENTHS_POSITION];
            var seconds = values[SECONDS_POSITION] + calculateIntegerUnitQuotient(secondTenths, SECOND_TENTHS_PER_SECOND);
            var minutes = values[MINUTES_POSITION] + calculateIntegerUnitQuotient(seconds, SECONDS_PER_MINUTE);
            var hours = values[HOURS_POSITION] + calculateIntegerUnitQuotient(minutes, MINUTES_PER_HOUR);
            var days = values[DAYS_POSITION] + calculateIntegerUnitQuotient(hours, HOURS_PER_DAY);
            values[SECOND_TENTHS_POSITION] = secondTenths % SECOND_TENTHS_PER_SECOND;
            values[SECONDS_POSITION] = seconds % SECONDS_PER_MINUTE;
            values[MINUTES_POSITION] = minutes % MINUTES_PER_HOUR;
            values[HOURS_POSITION] = hours % HOURS_PER_DAY;
            values[DAYS_POSITION] = days;
            return values;
          }
          function calculateIntegerUnitQuotient(unit, divisor) {
            var quotient = unit / divisor;
            return quotient < 0 ? Math.ceil(quotient) : Math.floor(quotient);
          }
          function setTarget(inputTarget) {
            if (!inputTarget) {
              return;
            }
            targetValues = configInputValues(inputTarget);
            var targetCounter = calculateTotalCounterFromValues(targetValues);
            targetDate = startingDate + targetCounter.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
            return targetValues;
          }
          function setStartValues(inputStartValues) {
            startValues = configInputValues(inputStartValues);
            counters.secondTenths = startValues[SECOND_TENTHS_POSITION];
            counters.seconds = startValues[SECONDS_POSITION];
            counters.minutes = startValues[MINUTES_POSITION];
            counters.hours = startValues[HOURS_POSITION];
            counters.days = startValues[DAYS_POSITION];
            totalCounters = calculateTotalCounterFromValues(startValues, totalCounters);
          }
          function calculateTotalCounterFromValues(values, outputCounter) {
            var total = outputCounter || {};
            total.days = values[DAYS_POSITION];
            total.hours = total.days * HOURS_PER_DAY + values[HOURS_POSITION];
            total.minutes = total.hours * MINUTES_PER_HOUR + values[MINUTES_POSITION];
            total.seconds = total.minutes * SECONDS_PER_MINUTE + values[SECONDS_POSITION];
            total.secondTenths = total.seconds * SECOND_TENTHS_PER_SECOND + values[[SECOND_TENTHS_POSITION]];
            return total;
          }
          function stop() {
            stopTimerAndResetCounters();
            dispatchEvent("stopped", eventData);
          }
          function reset() {
            stopTimerAndResetCounters();
            setParamsAndStartTimer(currentParams);
            dispatchEvent("reset", eventData);
          }
          function start() {
            var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            params = _objectSpread2(_objectSpread2({}, defaultParams), params);
            if (isRunning()) {
              return;
            }
            setParamsAndStartTimer(params);
            dispatchEvent("started", eventData);
          }
          function pause() {
            stopTimer();
            paused = true;
            dispatchEvent("paused", eventData);
          }
          function addEventListener(eventType, listener) {
            eventEmitter.on(eventType, listener);
          }
          function removeEventListener(eventType, listener) {
            eventEmitter.removeListener(eventType, listener);
          }
          function removeAllEventListeners(eventType) {
            eventEmitter.removeAllListeners(eventType);
          }
          function dispatchEvent(eventType, data) {
            eventEmitter.emit(eventType, data);
          }
          function isRunning() {
            return running;
          }
          function isPaused() {
            return paused;
          }
          function getTimeValues() {
            return counters;
          }
          function getTotalTimeValues() {
            return totalCounters;
          }
          function getConfig() {
            return timerConfig;
          }
          if (typeof this !== "undefined") {
            this.start = start;
            this.pause = pause;
            this.stop = stop;
            this.reset = reset;
            this.isRunning = isRunning;
            this.isPaused = isPaused;
            this.getTimeValues = getTimeValues;
            this.getTotalTimeValues = getTotalTimeValues;
            this.getConfig = getConfig;
            this.addEventListener = addEventListener;
            this.on = addEventListener;
            this.removeEventListener = removeEventListener;
            this.removeAllEventListeners = removeAllEventListeners;
            this.off = removeEventListener;
          }
        }
        exports2.Timer = Timer2;
        exports2["default"] = Timer2;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // app/scripts/password.js
  var import_easytimer = __toModule(require_easytimer());
  var pwPage = {
    init_EasyTimer: function(selector, time_second) {
      let timer = new import_easytimer.Timer();
      timer.start({ countdown: true, startValues: { seconds: time_second } });
      timer.addEventListener("secondsUpdated", function(e) {
        let d = timer.getTimeValues().days, h = timer.getTimeValues().hours, m = timer.getTimeValues().minutes, s = timer.getTimeValues().seconds;
        let totalHours = d * 24 + h;
        totalHours > 99 ? pwPage.easyTimer_HTML(selector.querySelector(".count-day"), d) : selector.querySelector(".count-day").classList.add("hide");
        pwPage.easyTimer_HTML(selector.querySelector(".count-hrs"), totalHours > 99 ? h : totalHours);
        pwPage.easyTimer_HTML(selector.querySelector(".count-min"), m);
        pwPage.easyTimer_HTML(selector.querySelector(".count-sec"), s);
        if (!JSON.parse(selector.getAttribute("data-hide-label"))) {
          let d_t = d > 1 ? theme.dateLabel.days : theme.dateLabel.day, h_t = h > 1 ? theme.dateLabel.hours : theme.dateLabel.hour, m_t = m > 1 ? theme.dateLabel.minutes : theme.dateLabel.minute, s_t = s > 1 ? theme.dateLabel.seconds : theme.dateLabel.second;
          selector.querySelector(".count-day .date-label").innerHTML = d_t;
          selector.querySelector(".count-hrs .date-label").innerHTML = h_t;
          selector.querySelector(".count-min .date-label").innerHTML = m_t;
          selector.querySelector(".count-sec .date-label").innerHTML = s_t;
        }
        selector.classList.add("countdown-loaded");
      });
      timer.addEventListener("targetAchieved", function(e) {
        selector.classList.add("hide");
      });
    },
    easyTimer_HTML: function(selector, value) {
      if (value > 9) {
        let arrValue = value.toString().split("");
        arrValue.forEach((val, index) => {
          let target = selector.querySelector(`.date-value[data-index="${index + 1}"]`);
          if (target == null) {
            let prevElment = selector.querySelector(`.date-value[data-index="${index}"]`);
            let renderHTML = prevElment.outerHTML.replace(`data-index="${index}"`, `data-index="${index + 1}"`).replace(`${prevElment.innerHTML}</span>`, `${arrValue[index]}</span`);
            selector.querySelector(`.date-value[data-index="${index}"]`).insertAdjacentHTML("afterend", renderHTML);
            return;
          }
          target.innerHTML = arrValue[index];
        });
      } else {
        selector.querySelector('.date-value[data-index="1"]').innerHTML = 0;
        selector.querySelector('.date-value[data-index="2"]').innerHTML = value;
      }
    },
    initCountdown: function(target = null) {
      let container = target;
      if (container == null) {
        container = document;
      }
      let countdownItems = container.querySelectorAll(".countdown-time:not(.countdown-loaded)");
      if (!countdownItems.length) {
        return;
      }
      countdownItems.forEach((e) => {
        if (!e.classList.contains("countdown-loaded")) {
          let _this = e, _value = _this.getAttribute("data-date").split("/"), _date = new Date(_value[2], Number(_value[0]) - 1, _value[1]).getTime() / 1e3, _now = new Date().getTime() / 1e3, countdownTime = _date > _now ? _date - _now : 0;
          if (countdownTime > 0)
            pwPage.init_EasyTimer(_this, countdownTime);
          else
            _this.remove();
        }
      });
    },
    init: function() {
      document.querySelector('label[for="password"]').addEventListener("click", function(e) {
        let target = document.getElementById("form__password");
        target.classList.toggle("show");
      });
      this.initCountdown();
    }
  };
  pwPage.init();
})();
